"use strict";

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpHeaders = void 0;

var HttpHeaders = /*#__PURE__*/function () {
  function HttpHeaders() {
    _classCallCheck(this, HttpHeaders);

    this.headers = {};
  }

  _createClass(HttpHeaders, [{
    key: "set",
    value: function set(key, value) {
      this.headers[key] = value;
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.headers.hasOwnProperty(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.headers[key];
    }
  }, {
    key: "remove",
    value: function remove(key) {
      if (!this.has(key)) throw new Error('They key was not present in the headers dictionary.');
      delete this.headers[key];
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var result = [];

      for (var key in this.headers) {
        result.push([key, this.headers[key]]);
      }

      return result;
    }
  }]);

  return HttpHeaders;
}();

exports.HttpHeaders = HttpHeaders;